/**
 * Hodnota `hasFocus` pro `PopupMenu.arangePopupToEditableControl`.
 *
 * `hasFocus` se v `arangePopupToEditableControl` používá pouze při zadaném parametru `gridRect`. A ten `ValidationErrorTooltip` nezadává.
 * Proto se focus nemusí řešit a může se předat libovolná hodnota.
 */
export const HAS_FOCUS_UNIMPORTANT = false;
